import React from "react";
import { STHead } from "@/components";
import { STAboutUs } from "@/components/STAboutUs";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("about-us");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching about-us page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

const AboutUs = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "About Us";
  const metaDescription =
    pageContent.meta_description ||
    "Deeptech startup using advanced biochemistry and chemistry for developing bio-materials for various industries.";
  const metaKeywords =
    pageContent.meta_keywords ||
    "About Sustanix, mission, green chemistry, sustainable additives";

  const ogTitle = pageContent.og_title || metaTitle || "Fundamental & Applied research on novel biomaterials";
  const ogDescription =
    pageContent.og_description ||
    metaDescription ||
    "We invent and scale novel chemistries & biochemistries in the biomaterials space for various industries";
  const ogKeywords = pageContent.og_keywords || metaKeywords;

  const getOgImage = () => {
    if (pageContent.og_image_url) return pageContent.og_image_url;
    if (pageContent.og_image) {
      if (
        pageContent.og_image.startsWith("http://") ||
        pageContent.og_image.startsWith("https://") ||
        pageContent.og_image.startsWith("/")
      ) {
        return pageContent.og_image;
      }
      return imageUrlBase.endsWith("/")
        ? `${imageUrlBase}${pageContent.og_image}`
        : `${imageUrlBase}/${pageContent.og_image}`;
    }
    return "https://sustanix.com/opengraph-image.webp";
  };

  const ogImage = getOgImage();

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/about-us/"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com/about-us/"
        ogImage={ogImage}
        ogType="website"
      />
      <STAboutUs pageData={pageData} slug="about-us" />
    </>
  );
};

export default AboutUs;

